import React from "react";
import Header from "../components/founding/Header";
import Hero from "../components/founding/Hero";
import ValueProps from "../components/founding/ValueProps";
import Incentives from "../components/founding/Incentives";
import HowItWorks from "../components/founding/HowItWorks";
import TrustStrip from "../components/founding/TrustStrip";
import FinalCTA from "../components/founding/FinalCTA";
import Footer from "../components/founding/Footer";

export default function FoundingCustomerLanding() {
  return (
    <main data-testid="landing-page" className="founding-page relative min-h-screen bg-bhyyve-bg text-bhyyve-ink antialiased" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <Header />
      <Hero />
      <ValueProps />
      <Incentives />
      <HowItWorks />
      <TrustStrip />
      <FinalCTA />
      <Footer />
    </main>
  );
}
